
import { overrideStore, parametrize } from 'react-overridable';

import { ResultsListItemWithState } from '@components_common/components/items/GlobalSearchResultListItem.jsx';


overrideStore.add('Datasets.Search.ResultsList.item', ResultsListItemWithState);
